import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Item } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'
import CashBack from 'features/CashBack/CashBack'

const TotalCashOnly = ({ installmentSelected, price, cart }) => {
  const installment = installmentSelected()
  let { shipping } = cart
  let shippingTotalPrice = shipping.totalCash

  if (!installment) {
    return <Fragment>
      <Item
        description='Valor em Total:'
        className='row pt-2 px-2'
        classFont='txt-body-sm color-ui-2'
      >
        <CatalogCurrencyLabel
          className='txt-bold color-brand-1'
          price={{
            cash: price
          }}
          checkCashOnly
        />
      </Item>
      <CashBack className={'box-cashback row pt-1 mt-1 px-2 border-top border-color-ui-4'} price={price - shippingTotalPrice} />
    </Fragment>
  }

  const totalPrice = installment.parcel * installment.parcelValue
  const priceInstallments = {
    cash: totalPrice
  }

  return (
    <Fragment>
      <Item
        description='Valor em Total:'
        className='row pt-2 px-2'
        classFont='txt-body-sm color-ui-2'
      >
        <CatalogCurrencyLabel
          className='txt-bold color-brand-1'
          price={priceInstallments}
          checkCashOnly
        />
      </Item>
      <CashBack className={'box-cashback row pt-1 mt-1 px-2 border-top border-color-ui-4'} price={totalPrice - shippingTotalPrice} />
    </Fragment>
  )
}

TotalCashOnly.propTypes = {
  installmentSelected: PropTypes.func.isRequired,
  price: PropTypes.object,
  cart: PropTypes.object.isRequired
}

export default TotalCashOnly



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/TotalCashOnly.js